<ng-template #fieldComponent />
<ish-field-tooltip [tooltipInfo]="props.tooltip" />
